"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const customDayHeader = (arg) => {
    const headerCell = ({ title, children }) => {
        return ((0, jsx_runtime_1.jsxs)("a", Object.assign({ style: { textAlign: 'center', fontSize: 12 } }, { children: [(0, jsx_runtime_1.jsxs)("span", Object.assign({ style: { textAlign: 'center', display: 'block' } }, { children: [arg.month, "/", title] })), children] })));
    };
    return headerCell;
};
exports.default = customDayHeader;
